__webpack_require__.S = {};
const initPromises = {};
const initTokens = {};
__webpack_require__.I = (name, initScope) => {
	if(!initScope) initScope = [];
	// handling circular init calls
	let initToken = initTokens[name];
	if(!initToken) initToken = initTokens[name] = {};
	if(initScope.indexOf(initToken) >= 0) return;
	initScope.push(initToken);
	// only runs once
	if(initPromises[name]) return initPromises[name];
	// creates a new share scope if needed
	if(!__webpack_require__.o(__webpack_require__.S, name)) __webpack_require__.S[name] = {};
	// runs all init snippets from all modules reachable
	const scope = __webpack_require__.S[name];
	const warn = (msg) => {
		if (typeof console !== "undefined" && console.warn) console.warn(msg);
	};
	const uniqueName = "react_form_3_1_13";
	const register = (name, version, factory, eager) => {
		const versions = scope[name] ||= {};
		const activeVersion = versions[version];
		if(!activeVersion || (!activeVersion.loaded && (!eager != !activeVersion.eager ? eager : uniqueName > activeVersion.from))) versions[version] = { get: factory, from: uniqueName, eager: !!eager };
	};
	const initExternal = (id) => {
		const handleError = (err) => (warn("Initialization of sharing external failed: " + err));
		try {
			const module = __webpack_require__(id);
			if(!module) return;
			const initFn = (module) => (module && module.init && module.init(__webpack_require__.S[name], initScope))
			if(module.then) return promises.push(module.then(initFn, handleError));
			const initResult = initFn(module);
			if(initResult?.then) return promises.push(initResult['catch'](handleError));
		} catch(err) { handleError(err); }
	}
	const promises = [];
	switch(name) {
		case "default": {
			register("@kne/current-lib_react-form", "3.1.13", () => (Promise.all([__webpack_require__.e(421), __webpack_require__.e(922), __webpack_require__.e(807)]).then(() => (() => (__webpack_require__(33807))))));
			register("@kne/global-context", "1.3.2", () => (Promise.all([__webpack_require__.e(884), __webpack_require__.e(785)]).then(() => (() => (__webpack_require__(61785))))));
			register("@kne/react-fetch", "1.5.7", () => (Promise.all([__webpack_require__.e(586), __webpack_require__.e(286), __webpack_require__.e(884)]).then(() => (() => (__webpack_require__(15286))))));
			register("@kne/react-intl", "0.1.15", () => (Promise.all([__webpack_require__.e(329), __webpack_require__.e(884), __webpack_require__.e(558), __webpack_require__.e(694)]).then(() => (() => (__webpack_require__(93329))))));
			register("@kne/remote-loader", "1.4.6", () => (Promise.all([__webpack_require__.e(586), __webpack_require__.e(884), __webpack_require__.e(13)]).then(() => (() => (__webpack_require__(18394))))));
			register("@kne/responsive-utils", "0.1.16", () => (Promise.all([__webpack_require__.e(884), __webpack_require__.e(873)]).then(() => (() => (__webpack_require__(97254))))));
			register("@kne/use-event", "0.1.5", () => (Promise.all([__webpack_require__.e(922), __webpack_require__.e(893)]).then(() => (() => (__webpack_require__(20893))))));
			register("antd", "5.29.3", () => (Promise.all([__webpack_require__.e(869), __webpack_require__.e(884), __webpack_require__.e(486), __webpack_require__.e(469), __webpack_require__.e(360)]).then(() => (() => (__webpack_require__(48869))))));
			register("antd", "6.6.4", () => (Promise.all([__webpack_require__.e(953), __webpack_require__.e(922), __webpack_require__.e(388)]).then(() => (() => (__webpack_require__(64953))))));
			register("axios", "1.20.0", () => (__webpack_require__.e(532).then(() => (() => (__webpack_require__(52532))))));
			register("dayjs", "1.11.23", () => (__webpack_require__.e(191).then(() => (() => (__webpack_require__(62191))))));
			register("dayjs", "1.11.23", () => (__webpack_require__.e(187).then(() => (() => (__webpack_require__(16187))))));
			register("react-dom", "18.3.1", () => (Promise.all([__webpack_require__.e(879), __webpack_require__.e(884)]).then(() => (() => (__webpack_require__(20879))))));
			register("react-dom", "18.3.1", () => (Promise.all([__webpack_require__.e(867), __webpack_require__.e(922)]).then(() => (() => (__webpack_require__(43867))))));
			register("react-router-dom", "6.30.6", () => (Promise.all([__webpack_require__.e(106), __webpack_require__.e(884), __webpack_require__.e(486)]).then(() => (() => (__webpack_require__(68106))))));
			register("react", "18.3.1", () => (__webpack_require__.e(198).then(() => (() => (__webpack_require__(49198))))));
			register("react", "18.3.1", () => (__webpack_require__.e(354).then(() => (() => (__webpack_require__(9354))))));
		}
		break;
	}
	if(!promises.length) return initPromises[name] = 1;
	return initPromises[name] = Promise.all(promises).then(() => (initPromises[name] = 1));
};